import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {} from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import 'zone.js';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import dayjs from 'dayjs';
import { Title } from '@angular/platform-browser';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var createGoogleEvent: any;

@Component({
  selector: 'mindbase-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    NgxUiLoaderModule
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'mindbase';

  constructor(
    public translate: TranslateService,
    private router: Router,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.title = this.getWebSettings()?.headerTitle || '';
      this.titleService.setTitle(this.title);
      const favicon = this.getWebSettings()?.favIcon || '';
      this.updateFavicon(favicon);
    }, 1000);

    if (isPlatformBrowser(this.platformId)) {
      this.translate.get('notificationAlert').subscribe(() => {
        // Check if translation exists and permission is denied
        if (
          Notification.permission === 'denied' &&
          this.translate.store.translations
        ) {
          // alert(this.translate.instant('notificationAlert'));
        }
      });
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });

    navigator.serviceWorker.addEventListener('message', event => {
      if (event.data && event.data.action === 'navigate') {
        window.location.href = event.data.url;
        // if (event.data.payload.notifications && event.data.payload.notifications.length > 0) {
        //   this._messagingService.sendMessage(event.data.payload.notifications);
        // }
      } else if (event.data && event.data.action === 'playNotificationSound') {
        this.playNotificationSound();
      }
    });
  }

  private playNotificationSound(): void {
    // const audio = new Audio(assets.notificationSound); // Adjust path as needed
    // audio.play().catch((error) => {
    //   console.error('Error playing notification sound:', error);
    // });
  }

  googleCalendarSync(): void {
    const bookingTime = dayjs().add(1, 'day').utc().format();
    const bookingEndTime = dayjs()
      .add(1, 'day')
      .add(15, 'minute')
      .utc()
      .format();
    const bookingTime1 = dayjs().add(1, 'day').add(30, 'minute').utc().format();
    const bookingEndTime1 = dayjs()
      .add(1, 'day')
      .add(45, 'minute')
      .utc()
      .format();
    const email = 'amol@apptunix.com';

    createGoogleEvent([
      { bookingTime,
        bookingEndTime,
        email },
      { bookingTime: bookingTime1,
        bookingEndTime: bookingEndTime1,
        email }
    ]);
  }

  getWebSettings(): any {
    const val = localStorage.getItem('webSettings');
    if (!val || val === 'undefined') return {};
    try {
      return JSON.parse(val);
    } catch {
      return {};
    }
  }

  updateFavicon(faviconUrl: string): void {
    const links = document.querySelectorAll('link[rel*=\'icon\']');
    links.forEach(link => link.parentNode?.removeChild(link));

    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.type = 'image/webp'; // adjust to your file type if needed
    newLink.href = `${faviconUrl}?v=${Date.now()}`; // cache busting
    document.head.appendChild(newLink);
  }
}
